import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const data = {
  title: `Attitudes toward privacy are changing, and businesses are having to keep up.`,
  description: `To meet demands for privacy and security, businesses have to dedicate more resources to ensuring customer data is collected in a secure manner, while still ensuring they're delivering the customer-first experiences that consumers expect.`,
}

const AttitudesTowardPrivacy: FC = () => {
  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <TextWrapper>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h2" variant="h2">
              {data.title}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pLarge">
              {data.description}
            </CopyText.Description>
          </CopyTextBase>
        </TextWrapper>
      </Section.Contents>
    </SectionBase>
  )
}

const TextWrapper = styled.div`
  max-width: 844px;
  margin: 0 auto;
`

export default AttitudesTowardPrivacy
